import React from 'react';
import { Box, Divider, Flex, Heading, HStack, Link, SimpleGrid, Stack, Text, VStack } from '@chakra-ui/react';
import { MoonStarIcon, InfoIcon } from 'lucide-react';
import { brand, whatsappHref } from '../data/brand';
const navLinks = [{
  label: 'Servicios',
  href: '#servicios'
}, {
  label: '¿Por qué consultarnos?',
  href: '#por-que'
}, {
  label: 'Acerca de nosotros',
  href: '#nosotros'
}, {
  label: 'Galería y equipo',
  href: '#galeria'
}, {
  label: 'Experiencias',
  href: '#experiencias'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Footer() {
  return <Box as="footer" bg="ink.800" color="cream.100" pt={{
    base: 14,
    md: 20
  }} pb={{
    base: 12,
    lg: 10
  }} px={{
    base: 5,
    md: 10,
    xl: 16
  }} borderTop="1px solid" borderColor="rgba(242,183,5,0.25)" data-id="element-62" data-mp="3lf598wdbrzp1">
      <SimpleGrid columns={{
      base: 1,
      md: 3
    }} spacing={{
      base: 10,
      md: 12
    }} data-id="element-63" data-mp="2a19sxkaopkw8">
        <VStack align="flex-start" spacing={4} data-id="element-64" data-mp="2ezuvhqdesgnu">
          <HStack spacing={3} data-id="element-65" data-mp="3l9adfilcf44f">
            <Flex align="center" justify="center" w="2.5rem" h="2.5rem" borderRadius="full" bg="crimson.500" color="cream.50" data-id="element-66" data-mp="3lalgfg6ys7uh">
              <MoonStarIcon size={19} aria-hidden="true" data-id="element-67" data-mp="3v5n6qfcz7fyn" />
            </Flex>
            <Text fontFamily="heading" fontSize="xl" fontWeight={700} color="cream.50" data-id="element-68" data-mp="3q7264ettau9o">
              {brand.name}
            </Text>
          </HStack>
          <Text fontSize="sm" color="cream.200" opacity={0.75} data-id="element-69" data-mp="34723g4s9vvk">
            Orientación espiritual y prácticas esotéricas tradicionales, con atención personalizada
            desde Miami, Florida.
          </Text>
        </VStack>

        <VStack align="flex-start" spacing={3} data-id="element-70" data-mp="cv1ruuh8ndlr">
          <Text fontSize="0.68rem" letterSpacing="0.26em" textTransform="uppercase" color="gold.400" data-id="element-71" data-mp="qthxei3d6y2b">
            Contacto
          </Text>
          <Link href={brand.phoneHref} fontSize="sm" _hover={{
          color: 'gold.300'
        }} data-id="element-72" data-mp="msy1fhuj20hr">
            Teléfono: {brand.phone}
          </Link>
          <Link href={whatsappHref()} isExternal fontSize="sm" _hover={{
          color: 'gold.300'
        }} data-id="element-73" data-mp="tt07un1zcgow">
            WhatsApp: {brand.whatsapp}
          </Link>
          <Link href={brand.emailHref} fontSize="sm" wordBreak="break-word" _hover={{
          color: 'gold.300'
        }} data-id="element-74" data-mp="13t0uahv5bcxb">
            {brand.email}
          </Link>
          <Text fontSize="sm" data-id="element-75" data-mp="1ckkoqrsr30mh">{brand.location}</Text>
        </VStack>

        <VStack align="flex-start" spacing={3} data-id="element-76" data-mp="1hkfg0wgfts82">
          <Text fontSize="0.68rem" letterSpacing="0.26em" textTransform="uppercase" color="gold.400" data-id="element-77" data-mp="1hj4cmxqwmmhh">
            Navegación
          </Text>
          {navLinks.map(link => <Link key={link.href} href={link.href} fontSize="sm" _hover={{
          color: 'gold.300'
        }} data-id="element-78" data-mp="1rhtw2uyg8ezu">
              {link.label}
            </Link>)}
        </VStack>
      </SimpleGrid>

      <Box id="informacion-importante" mt={{
      base: 12,
      md: 16
    }} bg="rgba(250,243,232,0.05)" border="1px solid" borderColor="rgba(250,243,232,0.14)" borderLeft="4px solid" borderLeftColor="gold.400" px={{
      base: 5,
      md: 8
    }} py={{
      base: 6,
      md: 7
    }} data-id="element-79" data-mp="3t9gfobg0h7ma">
        <Flex align="center" gap={3} mb={4} data-id="element-80" data-mp="21nbjhitqk0gm">
          <Box as={InfoIcon} width="1.25rem" height="1.25rem" color="gold.400" aria-hidden="true" data-id="element-81" data-mp="1wnyyz4qc75h7" />
          <Heading as="h2" fontSize={{
          base: 'lg',
          md: '1.5rem'
        }} color="cream.50" data-id="element-82" data-mp="2tdpun7ad6yol">
            Información importante
          </Heading>
        </Flex>
        <VStack align="flex-start" spacing={3} data-id="element-83" data-mp="2pcw8ojghftyc">
          <Text fontSize={{
          base: 'sm',
          md: 'md'
        }} color="cream.100" opacity={0.85} data-id="element-84" data-mp="2kd1hsfwpj4da">
            Los servicios ofrecidos son de carácter espiritual, recreativo y de entretenimiento. No
            garantizan resultados específicos y los resultados pueden variar de una persona a otra.
            Estos servicios no sustituyen atención médica, psicológica, legal o financiera.
          </Text>
          <Text fontSize={{
          base: 'sm',
          md: 'md'
        }} color="cream.100" opacity={0.85} data-id="element-85" data-mp="2rvzk96vevtqj">
            Las consultas pueden realizarse de manera voluntaria y bajo responsabilidad del cliente.
          </Text>
        </VStack>
      </Box>

      <Divider borderColor="rgba(250,243,232,0.14)" my={{
      base: 8,
      md: 10
    }} data-id="element-86" data-mp="2iw44sputpckp" />

      <Stack direction={{
      base: 'column',
      md: 'row'
    }} justify="space-between" align={{
      base: 'flex-start',
      md: 'center'
    }} spacing={4} data-id="element-87" data-mp="2ntmdqg8ubrsp">
        <Text fontSize="xs" color="cream.200" opacity={0.6} data-id="element-88" data-mp="3flbpxwrj5jo3">
          © {new Date().getFullYear()} {brand.name}. Todos los derechos reservados.
        </Text>
        <HStack spacing={6} data-id="element-89" data-mp="31l0yariec11v">
          <Link href="#informacion-importante" fontSize="xs" color="cream.200" _hover={{
          color: 'gold.300'
        }} data-id="element-90" data-mp="31nx1ovd0jhxp">
            Términos y condiciones
          </Link>
          <Link href="#informacion-importante" fontSize="xs" color="cream.200" _hover={{
          color: 'gold.300'
        }} data-id="element-91" data-mp="1q4sukmr8ajom">
            Política de privacidad
          </Link>
        </HStack>
      </Stack>
    </Box>;
}